import React, { useContext } from 'react';
import { useStaticQuery, graphql } from 'gatsby';

import { Query } from '../../../../__generated__/gatsby-types';
import { LanguageContext } from '../../../../providers/LanguageProvider';
import BroadcastCommunicationBanner from '../../../BroadcastCommunication/BroadcastCommunicationBanner';
import RichText, { richTextStyles } from '../../../../components/rich-text';

const BroadcastOutagesCommunicationQuery = graphql`
  {
    allContentfulOutageMapBroadcastMessage(
      filter: { contentful_id: { ne: "15SGPtRNhBt2fv4KYmNNU8" } }
    ) {
      nodes {
        ...BroadcastOutageMessage
      }
    }
  }
`;

const BroadcastOutageCommunication = () => {
  const richText = richTextStyles();

  const { allContentfulOutageMapBroadcastMessage } = useStaticQuery<Query>(
    BroadcastOutagesCommunicationQuery,
  );
  const { language } = useContext(LanguageContext);
  const outageMessage = allContentfulOutageMapBroadcastMessage?.nodes?.filter(
    node => node?.node_locale === language,
  );

  return (
    <>
      {outageMessage && outageMessage[0] && (
        <BroadcastCommunicationBanner
          data-testid="broadcast-banner"
          key={outageMessage[0].id}
          severity={outageMessage[0].messageType?.toLowerCase() as any}
          messageBody={
            outageMessage[0].messageBody && (
              <RichText className={`RichText ${richText.styles}`}>
                {outageMessage[0].messageBody}
              </RichText>
            )
          }
        />
      )}
    </>
  );
};

export default BroadcastOutageCommunication;
